<div class="theme-selector-container">
    <mat-icon>light_mode</mat-icon>
    <mat-slide-toggle (change)="toggle($event)" [checked]="isDarkTheme"></mat-slide-toggle>
    <mat-icon>dark_mode</mat-icon>
</div>
